import React from "react";
import { useDiaryContext } from "../../../../hooks/useDiaryContext";
import {
  runsheetConfigOptions,
  updateRunsheetConfig
} from "./ViewRunsheetConfigController";

import { Switch } from "../../../ui/switch";

const ViewRunsheetConfig = () => {
  const { runsheetConfig, setDiaryContext } = useDiaryContext();

  return (
    <div className="space-y-4">
      {runsheetConfigOptions.map((option) => (
        <div
          key={option.key}
          className="flex items-center justify-between gap-3"
        >
          <label className="text-sm font-medium text-foreground flex-1 min-w-0">
            {option.label}
          </label>
          <Switch
            checked={!!runsheetConfig[option.key]}
            onCheckedChange={(checked) => {
              updateRunsheetConfig({
                update: { [option.key]: checked },
                runsheetConfig,
                setDiaryContext
              });
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default ViewRunsheetConfig;
